import { ambienteAtual, ROTULO, type Ambiente } from "@/ambiente";

/*
 * O selo de ambiente é OBRIGATÓRIO e impossível de ignorar (doc 06a §4.1):
 * "operador cancelando boleto no ambiente errado é incidente de dinheiro real".
 *
 * Produção é pílula tingida VERMELHA. Homologação é âmbar, e vem com listras
 * diagonais atravessando o cabeçalho inteiro — o cabeçalho é o que está sempre
 * na tela, e a listra é visível pelo canto do olho de quem já parou de ler o
 * selo depois da terceira semana.
 */
const ESTILO: Record<Ambiente, string> = {
  producao: "border-falha/40 bg-falha/12 text-falha",
  homologacao: "border-transito/40 bg-transito/12 text-transito",
  local: "border-fio-forte bg-superficie-2 text-texto-2",
};

export function SeloDeAmbiente() {
  const ambiente = ambienteAtual();

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-[2px] text-rotulo font-medium uppercase tracking-[0.08em] ${ESTILO[ambiente]}`}
    >
      {ROTULO[ambiente]}
    </span>
  );
}

/** As listras diagonais que atravessam o cabeçalho fora de produção. */
export function ListrasDeAmbiente() {
  const ambiente = ambienteAtual();
  if (ambiente === "producao") return null;

  return (
    <div
      aria-hidden="true"
      className={[
        "pointer-events-none absolute inset-0 opacity-[0.06]",
        ambiente === "homologacao" ? "listras-atencao" : "listras-neutras",
      ].join(" ")}
    />
  );
}
